import { useEffect, useState } from "react";
import { matchRoute, currentUrl, type Route } from "./router";

export function useRoute(): Route {
  const [route, setRoute] = useState<Route>(() => matchRoute(currentUrl()));
  useEffect(() => {
    const on = () => setRoute(matchRoute(currentUrl()));
    window.addEventListener("popstate", on);
    return () => window.removeEventListener("popstate", on);
  }, []);
  useEffect(() => {
    /*
     * Legacy 경로는 화면만 옳게 열고 끝내지 않는다. 주소창에 그대로 남으면
     * 그 링크가 계속 공유되고 정규 경로는 영영 정규가 되지 못한다.
     *
     * 의존 배열이 `[route.path]` 였다. 정규 경로가 **직전과 같으면** 값이 안
     * 바뀌어서 이 효과가 통째로 건너뛰어졌다. 같은 곳으로 보내는 legacy 주소가
     * 여럿이면(`/collection` 과 `/passport/collection` 은 둘 다 스탬프 북) 두
     * 번째부터 주소창이 그대로 남는다. 실제로 그랬다.
     *
     * 비교 대상은 route 가 아니라 **지금 주소창**이다. route 는 popstate 마다
     * 새 객체라 매번 돌고, 본문은 다르면 고치고 같으면 아무 일도 하지 않는다.
     */
    if (route.path !== window.location.pathname) {
      window.history.replaceState({}, "", route.path + window.location.search);
    }
  }, [route]);
  useEffect(() => {
    /* 화면이 바뀌면 스크린리더에 알린다. 라우팅은 시각 변화만으로 끝나지 않는다. */
    const live = document.getElementById("om-live");
    if (live) live.textContent = ROUTE_TITLE[route.name] ?? "";
  }, [route.name]);
  return route;
}

export const ROUTE_TITLE: Record<string, string> = {
  home: "홈", map: "지도", explore: "탐색", exploreCategory: "탐색",
  search: "검색", place: "장소 상세", events: "이벤트", event: "이벤트 상세",
  passport: "덕질 여권", me: "MY", settings: "설정", submit: "제보하기", visitNew: "방문 기록",
  legal: "약관", notFound: "페이지를 찾을 수 없음",
};
